import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';
import { ErrorMessage } from 'src/domains/layouts/shared/formComponents/FormComponents.style';
import { FormComponent } from 'src/domains/layouts/shared/cms/form/Form.style';
import { FormHeader } from 'src/domains/layouts/shared/cms/form/formHeader/FormHeader';
import { ContentH5, ParagraphDefault } from 'src/domains/layouts/shared/typography/Content.style';
import { Popup } from 'src/domains/layouts/shared/popup/Popup';
import { SuccessPopup } from 'src/domains/layouts/shared/popup/popups/cms/SuccessPopup';
import { InputRow } from 'src/domains/layouts/shared/formComponents/input/Input.style';
import { Input } from 'src/domains/layouts/shared/formComponents/input/Input';
import { Button } from 'src/domains/layouts/shared/buttons/Button';
import { ButtonOnInputSide } from 'src/domains/layouts/shared/buttons/Button.style';
import { TopEventsEventFormState } from './TopEventsState';
import { EventDataWrapper, TopEventsFormWrapper } from './TopEvents.style';

type PropsType = {
    onCreate: () => void;
};

export const TopEventsEventForm = observer('SportsForm', ({ onCreate }: PropsType) => {
    const {
        cmsState: { topEventsState },
        sdkStaff,
        trpcClient,
    } = useAppStateContext();
    const [topEventsEventFormState] = useState(
        () => new TopEventsEventFormState(trpcClient, topEventsState, sdkStaff.models)
    );

    const {
        eventId,
        sportName,
        competitionName,
        eventName,
        handleFindEvent,
        eventFoundData,
        isEventValid,
        handleCreateEvent,
        showCreatedPopup,
        handleHideCreatedPopup,
        isButtonDisabled,
        errorMessageForList,
    } = topEventsEventFormState;
    return (
        <TopEventsFormWrapper>
            <FormHeader
                isEditMode={false}
                defaultLabel='Create Top Event'
            >
                Enter Event ID. If the event is from a sport or competition that don’t already have a category, it will
                automatically create one.
            </FormHeader>

            <FormComponent
                onSubmit={(e: React.FormEvent<HTMLFormElement>): void => {
                    e.preventDefault();
                }}
            >
                <Loader isActive={false} />
                <InputRow>
                    <Input
                        label='Event ID*'
                        isError={isEventValid === false}
                        isEmpty={eventId.value === ''}
                        formInputState={eventId}
                        dataTest='topEvents-event-id-input'
                    />
                    <ButtonOnInputSide
                        size='regular'
                        version='secondary'
                        disabled={isEventValid === false}
                        onClick={(): Promise<void> => handleFindEvent()}
                        data-test='topEvents-event-find-button'
                    >
                        Find Event
                    </ButtonOnInputSide>
                </InputRow>
                {eventFoundData === null ? null : (
                    <>
                        <EventDataWrapper>
                            <ContentH5>Sport:</ContentH5>
                            <ParagraphDefault data-test='topEvents-event-found-sport'>{sportName}</ParagraphDefault>
                            <ContentH5>Competition:</ContentH5>
                            <ParagraphDefault data-test='topEvents-event-found-competition'>
                                {competitionName}
                            </ParagraphDefault>
                            <ContentH5>Event:</ContentH5>
                            <ParagraphDefault data-test='topEvents-event-found-event'>{eventName}</ParagraphDefault>
                        </EventDataWrapper>

                        <Button
                            isDisabled={isButtonDisabled}
                            onClick={async (): Promise<void> => {
                                await handleCreateEvent();
                                onCreate();
                            }}
                            dataTest='topEvents-event-create-button'
                        >
                            Create Event
                        </Button>
                    </>
                )}
                {showCreatedPopup === false ? null : (
                    <Popup
                        width={384}
                        handleHidePopup={handleHideCreatedPopup}
                    >
                        <SuccessPopup
                            handleHidePopup={handleHideCreatedPopup}
                            itemLabel='topEvents event'
                        />
                    </Popup>
                )}
                {errorMessageForList !== null && <ErrorMessage>{errorMessageForList}</ErrorMessage>}
            </FormComponent>
        </TopEventsFormWrapper>
    );
});
